const userRole = {
    admin: 'Administrator',
    localAdmin: 'LocalAdministrator',
    write: 'WriteUser',
    read: 'ReadUser'
};

export default userRole;